/**
 * Simple Checkout Button
 * Adds product to cart and opens delivery date picker popup
 */

(function() {
  'use strict';

  // Prevent duplicate initialization
  if (window.simpleCheckoutInitialized) {
    console.log('Simple checkout already initialized, skipping...');
    return;
  }
  window.simpleCheckoutInitialized = true;

  console.log('Simple checkout script loaded');

  // Track if checkout is in progress to prevent duplicate clicks
  let checkoutInProgress = false;

  /** Fixed מארז: one cart line = N meals (variant id → meal count). */
  const PROMEAL_FIXED_BOX_MEALS_BY_VARIANT = {
    '45675211554977': 10, // מארז עלייה במסה
    '45670205161633': 10, // מארז ירידה במשקל
  };

  function mainDishCountForVariant(variantId, button) {
    const vid = String(variantId || '');
    if (PROMEAL_FIXED_BOX_MEALS_BY_VARIANT[vid]) {
      return PROMEAL_FIXED_BOX_MEALS_BY_VARIANT[vid];
    }
    const raw =
      (button && button.dataset.mainDishCount) ||
      document.querySelector('meta[name="box-main-dish-count"]')?.content;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n >= 5 ? n : null;
  }

  async function addToCartAndShowDeliveryPicker(variantId, quantity = 1, button) {
    // Prevent duplicate calls
    if (checkoutInProgress) {
      console.log('Checkout already in progress, ignoring duplicate call');
      return;
    }
    
    checkoutInProgress = true;

    try {
      console.log('Adding to cart:', { variantId, quantity });

      const lineItem = { id: variantId, quantity: quantity };
      const mainDishUnits = mainDishCountForVariant(variantId, button);
      if (mainDishUnits != null) {
        lineItem.properties = { _main_dish_count: String(mainDishUnits) };
      }

      // Add to cart using Shopify Cart API
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [lineItem]
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      const data = await response.json();
      console.log('Added to cart successfully:', data);

      // Reset button state before showing popup
      if (button) {
        button.disabled = false;
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        button.style.pointerEvents = 'auto';
        button.textContent = button.dataset.originalText || 'הזמינו עכשיו';
      }
      checkoutInProgress = false;

      // Dispatch event to show the delivery date picker popup (drawer version is globally available)
      // Wait a moment for cart state to be fully updated
      setTimeout(() => {
        console.log('Dispatching show-delivery-selector event');
        document.dispatchEvent(new CustomEvent('show-delivery-selector', {
          detail: { 
            isDrawer: true,
            target: 'drawer'
          }
        }));
      }, 300);

    } catch (error) {
      console.error('Error adding to cart:', error);
      checkoutInProgress = false;
      alert('מצטערים, אירעה שגיאה. אנא נסו שוב.');
    }
  }

  /**
   * Initialize all checkout buttons
   */
  function initCheckoutButtons() {
    // Remove any existing event listeners by cloning buttons
    const buttons = document.querySelectorAll('.simple-checkout-btn:not([data-checkout-initialized])');
    
    console.log(`Found ${buttons.length} checkout button(s) to initialize`);
    
    buttons.forEach(button => {
      // Mark as initialized to prevent duplicate handlers
      button.setAttribute('data-checkout-initialized', 'true');
      
      // Get variant ID from data attribute or page meta
      const variantId = button.dataset.variantId 
        || document.querySelector('meta[name="product-variant-id"]')?.content;

      if (!variantId) {
        console.warn('No variant ID found for checkout button:', button);
        return;
      }

      console.log('Initializing checkout button with variant ID:', variantId);

      // Store original text for later restoration
      button.dataset.originalText = button.textContent;

      // Add click handler
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Prevent duplicate clicks
        if (checkoutInProgress) {
          console.log('Checkout already in progress');
          return;
        }
        
        // Disable button during processing
        button.disabled = true;
        button.style.opacity = '0.6';
        button.style.cursor = 'not-allowed';
        button.style.pointerEvents = 'none';
        
        button.textContent = 'מוסיף לסל...';

        addToCartAndShowDeliveryPicker(variantId, 1, button)
          .catch(() => {
            // Re-enable button if there's an error
            checkoutInProgress = false;
            button.disabled = false;
            button.style.opacity = '1';
            button.style.cursor = 'pointer';
            button.style.pointerEvents = 'auto';
            button.textContent = button.dataset.originalText || 'הזמינו עכשיו';
          });
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutButtons);
  } else {
    initCheckoutButtons();
  }

  // Re-initialize if new buttons are added dynamically
  const observer = new MutationObserver(() => {
    const newButtons = document.querySelectorAll('.simple-checkout-btn:not([data-checkout-initialized])');
    if (newButtons.length > 0) {
      initCheckoutButtons();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Allow other scripts to request re-init (e.g. after syncing variant onto a button)
  document.addEventListener('simple-checkout-reinit', initCheckoutButtons);

})();

